export const GET_USER_MOVIES = "LISTEN_TO_USER_MOVIES";
export const ADD_MOVIE_TO_WATCHLIST = "ADD_MOVIE_TO_WATCHLIST";
export const ADD_MOVIE_TO_FAVOURITES = "ADD_MOVIE_TO_FAVOURITES";
export const REMOVE_MOVIE_FROM_WATCHLIST = "REMOVE_MOVIE_FROM_WATCHLIST";
export const REMOVE_MOVIE_FROM_FAVOURITES = "REMOVE_MOVIE_FROM_FAVOURITES";
